import React, { forwardRef, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Tile, TileContent, TileText } from '@one-thd/sui-atomic-components';
import classNames from 'classnames';
import { AssistanIcon } from '../../../assets/AssistanIcon';

const SuggestedQuestions = forwardRef(({
  questions,
  onClick,
  drawerState,
  withAskPrompt,
  handleAskPromptClick,
  truncate
}, ref) => {
  const questionClasses = useMemo(() => classNames(
    'sui-flex sui-gap-4 sui-content-stretch sui-mb-4 sui-mt-2 sui-items-start',
    drawerState !== 'OPEN' ? 'sui-flex-row sui-overflow-x-scroll' : 'sui-flex-col'
  ), [drawerState]);

  if (!questions?.length) return null;
  // eslint-disable-next-line max-len
  const pillClasses = 'sui-bg-primary sui-rounded-lg sui-border-solid sui-rounded-base sui-text-primary hover:sui-outline hover:sui-outline-2 hover:-sui-outline-offset-2 focus-visible:sui-outline focus-visible:sui-outline-input-focus focus-visible:sui-outline-4 focus-visible:-sui-outline-offset-4 sui-border-1 sui-p-[7px] sui-border-input-primary hover:sui-outline-button-hover-accent';
  const askPrompt = 'Ask a question';

  return (
    <div className={questionClasses} data-testid="suggested-questions" ref={ref}>
      {withAskPrompt && (
        <div className="sui-flex sui-shrink-0 sui-grow" key="ask-prompt">
          <Tile
            className={pillClasses}
            onClick={handleAskPromptClick}
            value={askPrompt}
            data-testid="suggested-question"
          >
            <TileContent>
              <TileText truncate={truncate}>{askPrompt}</TileText>
            </TileContent>
          </Tile>
        </div>
      )}
      {questions.map((question, i) => ([
        <div className="sui-flex sui-shrink-0 sui-grow" key={i}>
          <Tile
            className={pillClasses}
            onClick={() => onClick(question)}
            value={question}
            data-testid="suggested-question"
          >
            <TileContent>
              <AssistanIcon height="16px" width="16px" color="brand" />
              <TileText truncate={truncate}>{question}</TileText>
            </TileContent>
          </Tile>
        </div>
      ]))}
    </div>
  );
});

SuggestedQuestions.propTypes = {
  withAskPrompt: PropTypes.bool,
  questions: PropTypes.arrayOf(PropTypes.string),
  onClick: PropTypes.func.isRequired,
  drawerState: PropTypes.string.isRequired,
  handleAskPromptClick: PropTypes.func,
  truncate: PropTypes.bool,
};

SuggestedQuestions.defaultProps = {
  withAskPrompt: false,
  questions: [],
  handleAskPromptClick: () => {},
  truncate: false,
};

export { SuggestedQuestions };
